// Shared atoms used by every HR sub-section.
// Keeping these tiny + dumb so the per-section components stay focused.
import React from "react";

export const Loading = () => <div className="p-8 text-center text-sm text-slate-500">Loading…</div>;
export const Empty = ({ text }) => <div className="p-10 text-center text-sm text-slate-500">{text || "No records yet."}</div>;
export const Row = ({ label, children }) => (
  <div><div className="text-[10px] font-mono-alt uppercase tracking-widest text-slate-500">{label}</div><div className="mt-1 font-medium text-slate-800">{children}</div></div>
);
export const Panel = ({ title, icon, children }) => (
  <div className="dc-card">
    <div className="flex items-center gap-2 border-b border-slate-100 px-5 py-3">
      {icon} <h3 className="font-display text-[15px] font-semibold text-slate-900">{title}</h3>
    </div>
    {children}
  </div>
);
export const SimpleList = ({ title, note }) => (
  <div className="dc-card p-8 text-sm text-slate-600">
    <h3 className="font-display text-base font-semibold text-slate-900 mb-2">{title}</h3>
    <p>{note}</p>
  </div>
);

export function KPI({ label, value, tone = "slate" }) {
  const palette = {
    slate: "bg-slate-50 text-slate-900 border-slate-200",
    emerald: "bg-emerald-50 text-emerald-900 border-emerald-200",
    amber: "bg-amber-50 text-amber-900 border-amber-200",
    red: "bg-red-50 text-red-900 border-red-200",
    indigo: "bg-indigo-50 text-indigo-900 border-indigo-200",
  }[tone];
  return (
    <div className={`rounded-xl border p-4 ${palette}`}>
      <div className="text-[10px] font-mono-alt uppercase tracking-widest opacity-70">{label}</div>
      <div className="mt-1 font-display text-2xl font-semibold tabular-nums">{value ?? 0}</div>
    </div>
  );
}

export function ScoreBit({ label, pct, weight }) {
  return (
    <div data-testid={`scorebit-${label.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}>
      <div className="text-[10px] font-mono-alt uppercase tracking-widest text-slate-500">{label} <span className="text-slate-400">· {weight}</span></div>
      <div className="mt-1 flex items-center gap-2">
        <div className="h-2 flex-1 rounded-full bg-slate-100 overflow-hidden">
          <div className="h-full bg-[#1E5CBA]" style={{ width: `${pct}%` }} />
        </div>
        <span className="text-xs font-semibold text-slate-900">{pct}%</span>
      </div>
    </div>
  );
}

export function Mini({ label, value, color = "text-slate-900" }) {
  return (
    <div className="rounded-md bg-slate-50 p-2.5">
      <div className="text-[10px] font-mono-alt uppercase tracking-widest text-slate-500">{label}</div>
      <div className={`mt-1 text-lg font-display font-semibold ${color}`}>{value}</div>
    </div>
  );
}

export function WorkflowBadge({ status }) {
  const color = {
    submitted: "bg-slate-100 text-slate-700",
    finance_review: "bg-amber-100 text-amber-800",
    finance_cleared: "bg-blue-100 text-blue-800",
    finance_rejected: "bg-red-100 text-red-700",
    admin_review: "bg-indigo-100 text-indigo-800",
    approved: "bg-emerald-100 text-emerald-800",
    rejected: "bg-red-100 text-red-700",
    paid: "bg-emerald-600 text-white",
  }[status] || "bg-slate-100 text-slate-700";
  return <span className={`inline-block rounded px-2 py-0.5 text-[10px] font-mono-alt uppercase tracking-wider ${color}`}>{status?.replace(/_/g, " ")}</span>;
}

export function AttStatusBadge({ status }) {
  const map = {
    present: "bg-emerald-100 text-emerald-800",
    late: "bg-amber-100 text-amber-800",
    absent: "bg-red-100 text-red-700",
    leave: "bg-blue-100 text-blue-700",
    half_day: "bg-slate-100 text-slate-700",
  };
  return <span className={`inline-block rounded px-2 py-0.5 text-[10px] font-mono-alt uppercase tracking-wider ${map[status] || "bg-slate-100 text-slate-700"}`}>{status}</span>;
}
